/**
 * Hubble's Component Inspector config, set at boot.
 *
 * Kept apart from the inspector itself (`ComponentInspector.tsx`) because
 * the storage namespace has to be known before Hubble decides whether to
 * load the inspector at all: `isComponentInspectorEnabled()` reads
 * `hubble:component-inspector`, and the user-menu toggle writes it. This
 * module is small; the inspector and its source map are not.
 */

import { setInspectorConfig } from "@freightsimple/dev-tools/Inspector/inspectorConfig";

declare const __PROJECT_ROOT__: string;

export function configureComponentInspector(): void {
  setInspectorConfig({
    storageNamespace: "hubble",
    projectRoot: __PROJECT_ROOT__,
    // Wrapper components the inspector should "look through" — focusing on
    // them is rarely useful since they have no visible JSX of their own.
    transparentNames: new Set([
      "Dialog",
      "PageLayout",
      "Stack",
      "StackLayout",
      "Grid",
      "TabSection",
      "TabContent",
      "FixtureSwitcher",
      "InlineRow",
      "SplitRow",
      "ActionBar",
      "Tab",
    ]),
    // Components above `<Router>` (StrictMode, Providers) are app scaffold
    // and noise from the inspector's perspective.
    scaffoldComponentName: "Router",
    // PageErrorBoundary fires this event to deep-link the inspector at the
    // file that threw the error.
    openFileEventName: "hubble:open-file",
  });
}
